import { useEffect, useReducer } from 'react'
import { AnyAction } from 'redux'
import { GET_FINANCIAL_LIST } from '../../api/System_Api'
import { getSupplierId, isResponseCodeSuccess } from '../../tools/util'

// action 类型定义
const BRANDLIST_ACTION_TYPE = {
  CHANGE_TABLEDATA: 'BRANDLIST/CHANGE_TABLEDATA', // 获取数据
  CHANGE_LOADINGDATA: 'BRANDLIST/CHANGE_LOADINGDATA',
}

const { CHANGE_TABLEDATA, CHANGE_LOADINGDATA } = BRANDLIST_ACTION_TYPE

interface AllocationAddState {
  loading: boolean
  dataSource: any[]
}
// 默认数据
const defaultState: AllocationAddState = {
  loading: false,
  dataSource: [],
}
const reducer = (state = defaultState, action: AnyAction) => {
  const arr = { ...state }
  switch (action.type) {
    case CHANGE_TABLEDATA:
      arr.dataSource = action.value
      return arr
    case CHANGE_LOADINGDATA:
      arr.loading = action.value
      return arr
    default:
      return state
  }
}
// 设置Table数据
const setTableLoadingAction = (param: boolean) => ({
  type: CHANGE_LOADINGDATA,
  value: param,
})
// 设置Table数据
const setTableDataAction = (param: any[]) => ({
  type: CHANGE_TABLEDATA,
  value: param,
})

const useFinancialHooks = () => {
  const [statepages, dispatch] = useReducer(reducer, defaultState)
  const { dataSource, loading } = statepages

  useEffect(() => {
    getData()
  }, [])

  // 获取数据
  const getData = async () => {
    dispatch(setTableLoadingAction(true))
    const res = await GET_FINANCIAL_LIST({
      supplierId: getSupplierId(),
    })
    if (isResponseCodeSuccess(res.code)) {
      dispatch(setTableDataAction(res.data))
    }
    dispatch(setTableLoadingAction(false))
  }
  // 刷新
  const onRefresh = () => {
    getData()
  }

  return {
    dataSource,
    loading,
    onRefresh,
  }
}

export default useFinancialHooks
import { useEffect, useReducer } from 'react'
import { AnyAction } from 'redux'
import { GET_FINANCIAL_LIST } from '../../api/System_Api'
import { getSupplierId, isResponseCodeSuccess } from '../../tools/util'

// action 类型定义
const BRANDLIST_ACTION_TYPE = {
  CHANGE_TABLEDATA: 'BRANDLIST/CHANGE_TABLEDATA', // 获取数据
  CHANGE_LOADINGDATA: 'BRANDLIST/CHANGE_LOADINGDATA',
}

const { CHANGE_TABLEDATA, CHANGE_LOADINGDATA } = BRANDLIST_ACTION_TYPE

interface AllocationAddState {
  loading: boolean
  dataSource: any[]
}
// 默认数据
const defaultState: AllocationAddState = {
  loading: false,
  dataSource: [],
}
const reducer = (state = defaultState, action: AnyAction) => {
  const arr = { ...state }
  switch (action.type) {
    case CHANGE_TABLEDATA:
      arr.dataSource = action.value
      return arr
    case CHANGE_LOADINGDATA:
      arr.loading = action.value
      return arr
    default:
      return state
  }
}
// 设置Table数据
const setTableLoadingAction = (param: boolean) => ({
  type: CHANGE_LOADINGDATA,
  value: param,
})
// 设置Table数据
const setTableDataAction = (param: any[]) => ({
  type: CHANGE_TABLEDATA,
  value: param,
})

const useFinancialHooks = () => {
  const [statepages, dispatch] = useReducer(reducer, defaultState)
  const { dataSource, loading } = statepages

  useEffect(() => {
    getData()
  }, [])

  // 获取数据
  const getData = async () => {
    dispatch(setTableLoadingAction(true))
    const res = await GET_FINANCIAL_LIST({
      supplierId: getSupplierId(),
    })
    if (isResponseCodeSuccess(res.code)) {
      dispatch(setTableDataAction(res.data))
    }
    dispatch(setTableLoadingAction(false))
  }
  // 刷新
  const onRefresh = () => {
    getData()
  }

  return {
    dataSource,
    loading,
    onRefresh,
  }
}

export default useFinancialHooks
